import styled from '@emotion/styled';
import { StepConnector, stepConnectorClasses, Step, StepLabel, Stepper } from '@mui/material';
import { useMemo } from 'react';

const StepperStyled = styled(Stepper)(() => ({
  maxWidth: '350px',
  paddingTop: '40px',
  paddingBottom: '40px',
  '& .MuiStepIcon-root.Mui-active': { color: '##F3A937' },
  '& .MuiStepIcon-root.Mui-completed': { color: '#00CF99', opacity: 0.5 },
  '& .Mui-disabled .MuiStepIcon-root': { color: '#F3A937', opacity: 0.5 }
}));

const QontoConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#00CF99'
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#00CF99'
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#F3A937',
    borderTopWidth: 3,
    borderRadius: 1
  }
}));

const BadgeStepper = ({ activeStep = 1, count = 4 }: { activeStep?: number; count?: number }) => {
  // create array with length of count
  const steps = useMemo(() => new Array(count).fill(''), [count]);
  return (
    <StepperStyled activeStep={activeStep - 1} connector={<QontoConnector />}>
      {steps.map((_, index) => (
        <Step key={index}>
          <StepLabel></StepLabel>
        </Step>
      ))}
    </StepperStyled>
  );
};

export default BadgeStepper;
